import * as XLSX from "xlsx";
import React, { useState, useMemo } from "react";
import Sidebar from "../Components/Sidebar";
import excel from "../assests/images/excel img.png";
import { Link } from "react-router-dom";
import CreatePlan from "./CreatePlan";
import Constant from "../Components/Utils/Constant";
import axios from "axios";
import ReactPaginate from "react-paginate";
import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditSubscriptionForm from "../Components/models/EditSubscriptionForm";
import { useSelector } from "react-redux";

export default function Subscription() {
  const [showCreateplanForm, setShowCreateplanForm] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [totalCount, setTotalCount] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [subscription, setSubscription] = useState([]);
  const tableRef = React.createRef();
  const [editPopup, setEditPopup] = useState(false);
  const [cupon, setCupon] = useState([]);
  const [subscriptionToBlock, setSubscriptionToBlock] = useState(null);
  const [subscriptionToDelete, setSubscriptionToDelete] = useState(null);
  const highlightedId = useSelector((state) => state.DataReducer.highlightedId);
  const [showActiveConfirmation, setShowActiveConfirmation] = useState(false);
  const [statusFilter, setStatusFilter] = useState(null);

  const handleOptionChange = (event, plan) => {
    const selectedValue = event.target.value;
    event.target.value = "";
    if (selectedValue === "Edit") {
      setEditPopup(plan);
    } else if (selectedValue === "Delete") {
      openDeleteConfirmation(plan);
    } else if (selectedValue === "block") {
      handleBlockConfirmation(plan);
    }
  };

  const handleConfirmBlock = async () => {
    if (subscriptionToBlock) {
      try {
        const newBlockStatus = !subscriptionToBlock.active;
        const response = await axios.put(
          `${Constant.BASE_URL}/subscription/update/${subscriptionToBlock._id}`,
          { active: newBlockStatus }
        );
        if (response.status === 200) {
          fetchSubscription(currentPage);
          const message = newBlockStatus ? "Blocked" : "Activated";
          toast.success(`Subscription ${message} successfully!`);
        } else {
          toast.error("Failed to update subscription status.");
        }
      } catch (error) {
        console.error("Error blocking subscription:", error);
        toast.error("Failed to update subscription status.");
      } finally {
        setShowActiveConfirmation(false);
        setSubscriptionToBlock(null);
      }
    }
  };

  const handleBlockConfirmation = (plan) => {
    setSubscriptionToBlock(plan);
    setShowActiveConfirmation(true);
  };

  const handleCloseBlockConfirmation = () => {
    setShowActiveConfirmation(false);
    setSubscriptionToBlock(null);
  };

  const handleCreateplanClick = () => setShowCreateplanForm(true);
  const handleClosePopup = () => setShowCreateplanForm(false);

  useEffect(() => {
    const fetchCoupon = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(`${Constant.BASE_URL}/cupon/getCuponAccess`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        if (data && data.cupon) {
          setCupon(data.cupon);
        }
      } catch (error) {
        console.error("Error fetching coupons:", error);
      }
    };
    fetchCoupon();
  }, []);

  const handleExportToExcel = () => {
    if (tableRef.current) {
      const ws = XLSX.utils.table_to_sheet(tableRef.current);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
      XLSX.writeFile(wb, "tablexls.xlsx");
    }
  };

  const fetchSubscription = async (page) => {
    const token = localStorage.getItem("token");
    setLoading(true);
    try {
      const response = await fetch(
        `${Constant.BASE_URL}/subscription/getSubscriptionAccess?page=${page}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await response.json();
      if (data && data.subscription) {
        setSubscription(data.subscription);
        if (data.success) {
          setTotalCount(data.totalCount);
          setTotalPages(data.totalPages);
          setCurrentPage(page);
        }
      }
    } catch (error) {
      console.error("Error fetching subscription:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscription(currentPage);
  }, [currentPage, showCreateplanForm, editPopup]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  const openDeleteConfirmation = (subscription) => {
    setSubscriptionToDelete(subscription);
    setShowDeleteConfirmation(true);
  };

  const handleDelete = async () => {
    if (subscriptionToDelete) {
      try {
        const response = await axios.delete(
          `${Constant.BASE_URL}/subscription/delete/${subscriptionToDelete._id}`
        );
        if (response.status === 200) {
          setSubscription((prev) => prev.filter((s) => s._id !== subscriptionToDelete._id));
          toast.success("Subscription deleted successfully");
        } else {
          toast.error("Failed to delete subscription");
        }
      } catch (error) {
        console.error("Error deleting subscription:", error);
        toast.error("Failed to delete subscription");
      } finally {
        setShowDeleteConfirmation(false);
      }
    }
  };

  const processedSubscriptions = useMemo(() => {
    if (!statusFilter) {
      return subscription;
    }
    return subscription.filter(plan => {
      if (statusFilter === 'active') return plan.active === false;
      if (statusFilter === 'inactive') return plan.active === true;
      return true;
    });
  }, [subscription, statusFilter]);

  return (
    <Sidebar>
      <>
        <ToastContainer position="top-right" autoClose={3000} />
        <div className="p-3 bg-grey-300 lg:p-3 xl:p-3 2xl:p-6">
          {/* --- FIX START: Main container is now a flex column to manage its children's layout --- */}
          <div className="bg-white h-[78.55vh] flex flex-col" style={{ borderRadius: "0px 0px 11px 11px" }}>

            {/* Header: This part is unchanged */}
            <div className="flex-shrink-0 flex items-center px-4 py-3 bg-white lg:py-2 xl:py-3 2xl:py-3">
              <div className="flex-1">
                <div className="flex justify-between px-10 lg:w-full lg:px-1 ">
                  <div className="flex ">
                    <div style={{ background: "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)" }} className="flex items-center justify-center px-2 bg-white rounded-sm cursor-pointer lg:w-fit 2xl:px-3 lg:py-1 xl:py-2 2xl:py-3">
                      <div className="text-5lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-semibold">
                        <p>Subscription Plans: {totalCount || 0}</p>
                      </div>
                    </div>
                    <Link to="/subscriotionCuppon501 ">
                      <div style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }} className="lg:w-fit px-2 2xl:px-3 lg:py-1 xl:py-2 2xl:py-3 cursor-pointer flex justify-center items-center bg-white rounded-sm border border-white border-opacity-60 bg-white bg-opacity-57 backdrop-blur-[5.7px] ml-3">
                        <div className="text-5lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-semibold">
                          <p>Coupons : {cupon ? cupon.length : "0"}</p>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="flex-1 ">
                <div className="flex justify-end">
                  <div className="flex mx-5 border border-white rounded-md ">
                    <img onClick={handleExportToExcel} src={excel} alt="excel" className="w-10 2xl:w-[80px] lg:w-[25px] xl:w-[35px]" />
                  </div>
                  <div style={{ background: "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)" }} className="lg:w-fit px-2 2xl:px-3 cursor-pointer flex justify-center items-center bg-white rounded-md border border-white border-opacity-60 bg-white bg-opacity-57 backdrop-blur-[5.7px] ">
                    <div onClick={handleCreateplanClick} style={{ background: "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)" }} className="lg:w-fit px-4 2xl:px-6 py-2 cursor-pointer flex justify-center items-center bg-white rounded-md border">
                      <p className="text-5lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-semibold">Create Plan</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Table Container: This now grows to fill available space and scrolls internally */}
            <div className="flex-grow w-full overflow-y-auto">
              <table ref={tableRef} className="table w-full table-fixed divide-y divide-gray-200 table-hover table-bordered" id="myTable">
                <thead className="bg-gray-100">
                  <tr>
                    <th style={{ width: "15%" }}>Action</th>
                    <th style={{ width: "30%" }}>Plan Name</th>
                    <th style={{ width: "20%" }}>
                      <select onChange={(e) => setStatusFilter(e.target.value || null)} className="p-1 text-sm border rounded-md focus:outline-none">
                        <option value="">All Status</option>
                        <option value="active">Active</option>
                        <option value="inactive">Blocked</option>
                      </select>
                    </th>
                    <th style={{ width: "20%" }}>Users Assigned</th>
                    <th style={{ width: "15%" }}>Price</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 ">
                  {processedSubscriptions.map((plan, index) => (
                    <tr key={plan._id || index} className={index % 2 === 0 ? "bg-white" : "bg-gray-100"} style={{ background: highlightedId === plan._id ? "yellow" : "none" }}>
                      <td>
                        <div className="flex justify-center items-center">
                          <select onChange={(event) => handleOptionChange(event, plan)} className="lg:w-[67px] xl:w-[78px] 2xl:w-[120px] 2xl:text-xl py-1 text-center outline-none border rounded-md shadow-sm">
                            <option value="" disabled selected>Select</option>
                            <option value="Edit">Edit</option>
                            <option value="Delete">Delete</option>
                            <option value="block">{plan.active ? "Unblock" : "Block"}</option>
                          </select>
                        </div>
                      </td>
                      <td className="truncate px-2">{plan.planname}</td>
                      <td className="px-6 whitespace-nowrap">
                        {plan.active ? (<span className="text-black font-semibold">BLOCKED</span>) : (<span className="text-green-600 font-semibold">Active</span>)}
                      </td>
                      <td className="truncate px-2">{plan.planevisibility.join(", ")}</td>
                      <td className="truncate px-2">{plan.price}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination: Now correctly positioned at the bottom, inside the container */}
            <div className="flex-shrink-0 w-full flex items-center justify-between border-t lg:text-[10px] xl:text-[14px] 2xl:text-3xl lg:pt-1 xl:pt-1 2xl:pt-0 px-4 py-2">
                <div className="flex justify-start">
                    <p>
                        Showing <span className="text-blue-500">{(currentPage - 1) * 15 + 1}</span> to <span className="text-blue-500">{Math.min(currentPage * 15, totalCount || 0)}</span> of <span className="text-yellow-500">{totalCount}</span> entries
                    </p>
                </div>
                <div className="flex justify-start text-blue-500 pagination">
                    <ReactPaginate
                        previousLabel={"<"}
                        nextLabel={">"}
                        breakLabel={"..."}
                        pageCount={totalPages}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"flex items-center space-x-2"}
                        activeClassName={"bg-blue-500 text-white rounded-md"}
                        pageClassName={"px-3 py-1 rounded-md hover:bg-gray-200"}
                        previousClassName={"px-3 py-1 rounded-md hover:bg-gray-200"}
                        nextClassName={"px-3 py-1 rounded-md hover:bg-gray-200"}
                    />
                </div>
            </div>
            {showCreateplanForm && <CreatePlan onClose={handleClosePopup} />}
            {editPopup && <EditSubscriptionForm editPopup={editPopup} setEditPopup={setEditPopup} />}
          </div>
          {/* --- FIX END --- */}
        </div>

        {/* Modals are unchanged */}
        {showDeleteConfirmation && (
          <div className="pop-delete">
            <div className="flex items-center justify-center w-full">
              <div className="p-4 px-1 py-3 bg-white rounded-md shadow-md w-fit">
                <div className="mb-4 text-lg font-semibold text-center">Do you want to Delete?</div>
                <hr className="p-2 mt-1" />
                <div className="flex flex-col items-center justify-center py-5">
                  <button type="button" onClick={() => setShowDeleteConfirmation(false)} className="px-8 py-2 bg-white shadow-md rounded-sm">No</button>
                  <button onClick={handleDelete} className="px-8 py-2 mt-5 text-white rounded-sm" style={{ background: "radial-gradient(125% 125% at 85.42% 0%, #FFA6A6 0%, #F00 100%)"}}>Yes</button>
                </div>
              </div>
            </div>
          </div>
        )}
        {showActiveConfirmation && (
          <div className="pop-delete">
            <div className="flex items-center justify-center w-full">
              <div className="p-4 px-1 py-3 bg-white rounded-md shadow-md w-fit">
                <div className="lg:w-[280px] xl:w-[280px] 2xl:w-[500px] items-center justify-center">
                  <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl 2xl:py-3">
                    Do you want to {subscriptionToBlock?.active ? "Unblock" : "Block"} this plan?
                  </div>
                  <hr className="p-2 mt-1" />
                  <div className="flex flex-col py-5 justify-center items-center">
                    <button type="button" onClick={handleCloseBlockConfirmation} className="px-8 py-2 bg-white shadow-md rounded-sm">No</button>
                    <button onClick={handleConfirmBlock} className="px-8 py-2 mt-5 text-white rounded-sm" style={{ background: "radial-gradient(125% 125% at 85.42% 0%, #FFA6A6 0%, #F00 100%)" }}>Yes</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    </Sidebar>
  );
}